import { useEffect, useState } from 'react';
import Grafic from "./RederChart"
import app from "../../api/firebaseConf"
import { collection, getFirestore, getDocs } from "firebase/firestore";
import Select from 'react-select';
import ChartNumeric from './NumChart';

export default function Dashboard() {

  const [slot,setSlot] = useState([])
  const [selector, setSelector] = useState('')
  const [devices,setDevices]  = useState([])

  const db = getFirestore(app)

  const array = []
  useEffect(()=>{
    const getGrafics = async() =>{
      const datos = await getDocs(collection(db,'habitaciones'));    
      datos.forEach((doc) => {
        array.push({label: doc.data().nombre, value: doc.data().nombre})
        
      })
     setSlot(array)
    }
    getGrafics()
  },[selector])

  const handleSelect =(e) =>{
    setSelector(e.value)
    //console.log(e.value)
    const lista = []
    const getDataSlot = async(habitacion) =>{
      const datos = await getDocs(collection(db,'sensores')); 
      datos.forEach((doc)=>{
        if (habitacion===doc.data().habitacion){
          lista.push(doc.data())
        }
      })
      setDevices(lista)
      //console.log(lista)
    }
    getDataSlot(e.value)    
    
  }

  return (
    <>
    <div className='pt-14 sm:pt-0'>
      <h1 className="text-3xl font-press-start font-bold uppercase mb-4">Graficos</h1>
        <div className="w-60 pb-4">
          <Select onChange={handleSelect}
            defaultValue = {{label: 'Seleccione habitacion', value: 'empty'}}
            isSearchable={false} 
            options={slot}/>
        </div>
        <div className="grid grid-flow-row-dense grid-cols-2 lg:grid-cols-5 sm:grid-cols-3 gap-2 sm:gap-6 mb-6">
          
          { devices.map((e)=>{
            if(e.tipo==='numerico'){
              return <div key={e.nombre} className= {`bg-white p-3 rounded-2xl shadow-sm col-span-1`}>
                <ChartNumeric path={e.variable} label = {e.nombre} color = {e.color} unidad = {e.unidad}/>
              </div> 
            }else {
            return <div key={e.nombre} className= {`bg-white p-3 rounded-2xl shadow-sm ${e.tipo === 'line' ? "col-span-2": "col-span-1"}`}>
              <Grafic tipo={e.tipo} path = {e.variable} label = {e.nombre} color = {e.color} tiposw = {e.tipo_sw}/>
             </div>
            } })
          }
          
        </div>
        </div>
    </>
  )
}